import request from '@/config/axios'

/** 玄学修为等级规则 VO（固定 5 行：童蒙/入门/登堂/入室/宗师，仅可改 name/threshold） */
export interface LevelRuleVo {
  id: number
  levelNo: number
  name: string
  threshold: number
}

export const LevelRuleApi = {
  // 查询等级规则列表（level_no 升序）
  getLevelRuleList: () => {
    return request.get({ url: '/xuanxue/level-rule/list' })
  },
  // 新增等级（约束式：仅追加到末尾，门槛必须大于当前最大门槛，level_no 后端自动分配）
  createLevelRule: (data: { name: string; threshold: number }) => {
    return request.post({ url: '/xuanxue/level-rule/create', data })
  },
  // 更新等级规则（仅 name/threshold，保存后门槛必须严格递增）
  updateLevelRule: (data: LevelRuleVo) => {
    return request.put({ url: '/xuanxue/level-rule/update', data })
  },
  // 删除等级（任意行删除后压实重排 level_no，至少保留 2 个等级）
  deleteLevelRule: (id: number) => {
    return request.delete({ url: '/xuanxue/level-rule/delete?id=' + id })
  }
}
